/**
 * Filtro de estado del grid de prospectos (BR-PROSPECT-21).
 *
 * `ACTIVE` es el default implícito: si la query no manda `status`, el backend
 * devuelve solo los no archivados, que es lo que TypeORM ya hace por sí solo
 * gracias al @DeleteDateColumn.
 */
export const PROSPECT_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  ALL: 'all',
} as const;

export type ProspectStatus = (typeof PROSPECT_STATUS)[keyof typeof PROSPECT_STATUS];

export interface ProspectStatusOption {
  value: ProspectStatus;
  label: string;
}

export const PROSPECT_STATUS_OPTIONS: readonly ProspectStatusOption[] = [
  { value: PROSPECT_STATUS.ACTIVE, label: 'prospectStatus.active' },
  { value: PROSPECT_STATUS.ARCHIVED, label: 'prospectStatus.archived' },
  { value: PROSPECT_STATUS.ALL, label: 'prospectStatus.all' },
];
